import StoreSelectorMenu from './StoreSelectorMenu'

export default StoreSelectorMenu
